__turbopack_context__.v({
  "articleHead": "Article-module-scss-module__5TtcjG__articleHead",
  "articleHeadDate": "Article-module-scss-module__5TtcjG__articleHeadDate",
  "boldText": "Article-module-scss-module__5TtcjG__boldText",
  "contactWrapper": "Article-module-scss-module__5TtcjG__contactWrapper",
  "description": "Article-module-scss-module__5TtcjG__description",
  "divider": "Article-module-scss-module__5TtcjG__divider",
  "iframe": "Article-module-scss-module__5TtcjG__iframe",
  "image": "Article-module-scss-module__5TtcjG__image",
  "largeText": "Article-module-scss-module__5TtcjG__largeText",
  "leftPanel": "Article-module-scss-module__5TtcjG__leftPanel",
  "line": "Article-module-scss-module__5TtcjG__line",
  "mediaWrapper": "Article-module-scss-module__5TtcjG__mediaWrapper",
  "moduleWrapper": "Article-module-scss-module__5TtcjG__moduleWrapper",
  "normalText": "Article-module-scss-module__5TtcjG__normalText",
  "outerWrapper": "Article-module-scss-module__5TtcjG__outerWrapper",
  "readingLine": "Article-module-scss-module__5TtcjG__readingLine",
  "rightPanel": "Article-module-scss-module__5TtcjG__rightPanel",
  "root": "Article-module-scss-module__5TtcjG__root",
  "socialWrapper": "Article-module-scss-module__5TtcjG__socialWrapper",
  "taxonomy": "Article-module-scss-module__5TtcjG__taxonomy",
  "taxonomyItem": "Article-module-scss-module__5TtcjG__taxonomyItem",
  "taxonomyList": "Article-module-scss-module__5TtcjG__taxonomyList",
  "taxonomyWrapper": "Article-module-scss-module__5TtcjG__taxonomyWrapper",
  "virtualTour": "Article-module-scss-module__5TtcjG__virtualTour",
});
